import React from 'react';

export const TwitterLogo = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="20" cy="20" r="20" fill="#EAF3EF" />
    <path
      d="M16 10H9L17.26 21.014L9.45 30H12.1L18.488 22.651L24 30H31L22.392 18.522L29.8 10H27.15L21.164 16.886L16 10ZM25 28L13 12H15L27 28H25Z"
      fill="#343435"
    />
  </svg>
);
